// Chakra imports
import {
  Box,
  Button,
  Flex,
  useColorMode,
  useColorModeValue,
  Text,
  Spinner,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import PieChart from "components/charts/PieChart";
import Menu from "components/menu/MainMenu";
// Assets
import { pieChartOptions } from "variables/charts";
import { useState } from "react";
import { ModalVersion } from "./ModalVersion";
import { UseDashboard } from "hooks/DashboardHook";
import { useQuery } from "react-query";

interface VersionsCardProps {
  [x: string]: any;
  name: string;
}

export default function VersionsCard(props: VersionsCardProps) {
  const [filter, setFilter] = useState<number>(6);
  const [versionSelect, setVersionSelect] = useState<any>();
  const [openModal, setOpenModal] = useState(false);
  const { name, ...rest } = props;
  const theme = useColorMode();
  const themeSelect = theme.colorMode;

  const { findVersionsModule } = UseDashboard();
  const { data, isLoading, error } = useQuery(
    ["findVersionsModule", name, filter],
    () => findVersionsModule(filter, name),
  );

  // Chakra Color Mode
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Card
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      w="100%"
      h={"100%"}
      mb="0px"
      {...rest}
    >
      <Flex
        align="center"
        justify="space-between"
        textAlign="center"
        w="100%"
        pe="20px"
        pt="5px"
      >
        <Button
          bg={boxBg}
          fontSize="sm"
          fontWeight="500"
          color={textColorSecondary}
          borderRadius="7px"
        >
          {name}
        </Button>

        <Menu onFilterSelected={(data: number) => setFilter(data)} />
      </Flex>
      <Flex
        w="100%"
        h={"100%"}
        minH={"290px"}
        flexDirection={{ base: "column", lg: "column" }}
      >
        <Box minH="100%" minW="100%" mt="auto">
          {isLoading ? (
            <Flex alignItems={"center"} justify={"center"} w="full" h={"full"}>
              <Spinner w={32} h={32} />
            </Flex>
          ) : error ? (
            <Flex
              width={"100%"}
              height={"100%"}
              justify={"center"}
              align={"center"}
            >
              <Text align="center">{String(error || "")}</Text>
            </Flex>
          ) : data && data[name] && data[name].total ? (
            <PieChart
              key={themeSelect + filter + data.total}
              chartData={data[name].total}
              chartOptions={{
                labels: data[name].versions,
                theme: {
                  mode: themeSelect,
                },
                chart: {
                  width: "50px",
                  background: "transparent",
                  events: {
                    legendClick: function (
                      event: any,
                      index: any,
                      config: any,
                    ) {
                      setVersionSelect(data[name].versions[index]);
                      setOpenModal(true);
                    },
                  },
                },
                ...pieChartOptions,
              }}
            />
          ) : (
            <Flex align={"center"} justify={"center"} h={"100%"}>
              <Text align="center" fontWeight={"bold"} fontSize={"xl"}>
                Nenhum dado disponível
              </Text>
            </Flex>
          )}
        </Box>

        {openModal ? (
          <ModalVersion
            dias={filter}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            modulo={props.name}
            version={versionSelect}
          />
        ) : null}
      </Flex>
    </Card>
  );
}
